module.exports = __webpack_public_path__ + "static/media/how_zh_hk.f5802e6a.vtt";